import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap'
const Footer = (props) => {
  const date = new Date();
  return (
    <Fragment>
      <footer className="footer " style={{position:"fixed",width:"100%",zIndex:"9"}}>
        <Container fluid={true}>
          <Row>
            <Col md="12" className="footer-copyright text-center">
              <p className="mb-0">{"Copyright "+ date.getFullYear() +" © SARL WISER GLOBAL COMMUNICATION."}</p>
            </Col>
          </Row>
        </Container>
      </footer>
    </Fragment>
  );
}

export default Footer;